import { trimLower } from "@axtesys/react-tools"

const TRANSLITERATION: Record<string, string> = {
  ä: "ae",
  à: "a",
  á: "a",
  â: "a",
  æ: "ae",
  ã: "a",
  å: "aa",
  ā: "a",
  Ä: "Ae",
  À: "A",
  Á: "A",
  Â: "A",
  Æ: "Ae",
  Ã: "A",
  Å: "Aa",
  Ā: "A",

  ç: "c",
  ć: "c",
  č: "ch",
  Ç: "C",
  Ć: "C",
  Č: "Ch",

  é: "e",
  è: "e",
  ê: "e",
  ë: "e",
  ė: "e",
  É: "E",
  È: "E",
  Ê: "E",
  Ë: "E",
  Ė: "E",

  î: "i",
  ï: "i",
  í: "i",
  ī: "i",
  ì: "i",
  Î: "I",
  Ï: "I",
  Í: "I",
  Ī: "I",
  Ì: "I",

  ñ: "ny",
  ń: "n",
  Ñ: "Ny",
  Ń: "N",

  ö: "oe",
  ô: "o",
  ò: "o",
  ó: "o",
  õ: "o",
  œ: "oe",
  ø: "oe",
  ō: "o",
  Ö: "Oe",
  Ô: "O",
  Ò: "O",
  Ó: "O",
  Õ: "O",
  Œ: "Oe",
  Ø: "Oe",
  Ō: "O",

  ß: "ss",
  ś: "s",
  š: "sh",
  ẞ: "Ss",
  Ś: "S",
  Š: "Sh",

  ü: "ue",
  û: "u",
  ù: "u",
  ú: "u",
  ū: "u",
  Ü: "Ue",
  Û: "U",
  Ù: "U",
  Ú: "U",
  Ū: "U",

  ÿ: "y",
  Ÿ: "Y",

  "–": "-",
}

export function sanitizeSpecialCharacters(text?: string): string | undefined {
  if (!text) return text

  let sanitized = ""
  for (let i = 0; i < text.length; i++) {
    const char = text[i]
    sanitized += TRANSLITERATION[char] ?? char
  }

  return sanitized
}

export function sanitizeForSorting(text?: string): string | undefined {
  return sanitizeSpecialCharacters(trimLower(text ?? ""))
}
